module.exports = __webpack_public_path__ + "static/media/banner-bg-gray.0c9c61bc.jpg";